



































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { exists } from '@/util/inputValidation'
import RichtextField from '@/components/inputs/RichtextField.vue'
import CurrencyInput from './CurrencyInput.vue'
import draggable from 'vuedraggable'

type Lineitem = {
  id?: number
  description: string
  amount: number
}

@Component({
  components: {
    RichtextField,
    CurrencyInput,
    draggable,
  }
})
export default class InvoiceInput extends Vue {

  @Prop({ default: [] }) fixedLineitems!: Lineitem[] // Pass in optional fixed lineitems
  @Prop({ type: Array }) value!: Lineitem[]
  @Prop({ default: false }) editable!: boolean
  @Prop({ default: false }) orderable!: boolean
  @Prop({ default: false }) autofocus!: boolean

  localLineitems: Lineitem[] = []
  drag = false

  get allLineitems() {
    return [
      ...this.fixedLineitems,
      ...this.localLineitems,
    ]
  }

  lineitemRules = {
    description: [exists('Lineitem description required')],
    amount: [exists('Lineitem amount required'), (v: number) => v > 0 || 'Invalid amount'],
  }

  mounted() {
    this.localLineitems = this.value
  }

  lastVal: any = null
  @Watch('fixedLineitems')
  onFixedLineitemsChanged(val: Lineitem[]) {
    if (JSON.stringify(val) !== JSON.stringify(this.lastVal)) {
      this.update()
    }
    this.lastVal = val
  }

  addLineitem() {
    this.localLineitems.push({
      description: '',
      amount: 0,
    })
    this.update()
  }

  removeLineitem(i: number) {
    this.localLineitems.splice(i, 1)
    this.update()
  }

  dragStart() {
    this.drag = true
  }

  dragEnd(event: any) {
    this.drag = false
  }

  update() {
    this.$emit('input', this.localLineitems)
  }
}
